import { Badge } from '@/components/ui/badge';

export const CATEGORY_META = {
  completion: { label: 'Completion & Handover' },
  safety: { label: 'Safety & Services' },
  parking: { label: 'Parking' },
  amenities: { label: 'Amenities' },
  financial: { label: 'Financial' },
  defects: { label: 'Building defects' },
};

export const STATUS_META = {
  open: { label: 'Open', cls: 'bg-slate-100 text-slate-800 border-slate-300 dark:bg-slate-800 dark:text-slate-100' },
  progress: { label: 'Progress reported', cls: 'bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-200' },
  no_update: { label: 'No update in latest minutes', cls: 'bg-amber-50 text-amber-900 border-amber-300 dark:bg-amber-900/30 dark:text-amber-200' },
  resolved_reported: { label: 'Resolved – reported', cls: 'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-200' },
  resolved_verified: { label: 'Resolved – verified', cls: 'bg-emerald-600 text-white border-emerald-700' },
};

export const fmtDate = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : null);

export function StatusChip({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.open;
  return <Badge variant="outline" className={`text-[10px] font-semibold ${m.cls}`} data-testid={testid}>{m.label}</Badge>;
}

export function OverdueChip({ testid }) {
  return <Badge variant="outline" className="text-[10px] font-semibold bg-red-50 text-red-700 border-red-300 dark:bg-red-900/30 dark:text-red-200" data-testid={testid}>Overdue</Badge>;
}
